<template>
  <vx-card class="mb-5">
    <div class="flex flex-col">
      <div class="w-full">
        <s-item height="17px"></s-item>
      </div>
      <div class="w-2/3">
        <s-item height="17px"></s-item>
        <s-item height="17px"></s-item>
      </div>
    </div>
  </vx-card>
</template>

<script>
import SItem from "./Item";
export default {
  components: {
    SItem
  }
};
</script>
